// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InvoicePreview-Wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 100px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.InvoicePreview-Header .InvoicePreview-BillToName,
.InvoicePreview-Header .InvoicePreview-BillToAddress {
  background: transparent;
  font-size: inherit;
  color: inherit;
  border: solid 1px transparent !important;
  box-shadow: 0 0 0 0.25rem transparent !important;
}
.InvoicePreview-Header .InvoicePreview-BillToName:focus,
.InvoicePreview-Header .InvoicePreview-BillToAddress:focus {
  border: solid 1px var(--bs-border-color) !important;
  box-shadow: 0 0 0 0.25rem rgba(27, 62, 111, 0.15) !important;
}
.InvoicePreview-Header .ant-picker-input input {
  font-size: 1rem !important;
  color: var(--bs-primary);
}
.InvoicePreview-Header li > h6 {
  display: flex;
}

.InvoicePreview-Totals {
  position: relative;
}
.InvoicePreview-Totals .summary-row {
  height: 2.5rem;
  background: white;
  border-bottom: 1px solid #e0e0e0;
}
.InvoicePreview-Totals .summary-row .Input {
  border: none;
  box-shadow: none;
}
.InvoicePreview-Totals .CurrencyInput:before {
  display: none;
}
.InvoicePreview-Totals:after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 0;
  z-index: 500;
  width: 100%;
  height: 60px;
  background: linear-gradient(rgba(200, 200, 210, 0), rgba(200, 200, 210, 0.25));
  padding-right: 50px;
  pointer-events: none;
}
.InvoicePreview-Totals .discount span:first-child {
  padding-left: 0;
}
.InvoicePreview-Totals .discount::before {
  content: "-";
  font-size: 1.25rem;
}
.InvoicePreview-Totals .input-group-sm > .form-control {
  font-size: 1rem;
}
.InvoicePreview-Totals .TotalSavings {
  outline: none;
  border: 0;
  background: transparent;
  text-align: end;
}

.QueryFilters.InvoicePreviewFilters {
  gap: 8rem;
}

.InvoicePreview .SimpleTable .SimpleTable-Row > .SimpleTable-Cell {
  --base-count: 14;
  --base-width: calc(100% / var(--base-count));
  --cell-width: 1;
}
.InvoicePreview .SimpleTable .SimpleTable-Row > .SimpleTable-Cell.INDEX, .InvoicePreview .SimpleTable .SimpleTable-Row > .SimpleTable-Cell.TYPE, .InvoicePreview .SimpleTable .SimpleTable-Row > .SimpleTable-Cell.AIRPORT_CODE, .InvoicePreview .SimpleTable .SimpleTable-Row > .SimpleTable-Cell.SERVICER_IATA_AIRLINE_CODE, .InvoicePreview .SimpleTable .SimpleTable-Row > .SimpleTable-Cell.PILOTS, .InvoicePreview .SimpleTable .SimpleTable-Row > .SimpleTable-Cell.ATTENDANTS {
  --cell-width: 0.5;
  flex: 0 0 calc(var(--base-width) * var(--cell-width)) !important;
}
.InvoicePreview .SimpleTable .SimpleTable-Row > .SimpleTable-Cell.SCHEDULED_TIME, .InvoicePreview .SimpleTable .SimpleTable-Row > .SimpleTable-Cell.FLIGHT_NUMBER, .InvoicePreview .SimpleTable .SimpleTable-Row > .SimpleTable-Cell.IMPORT_TIME {
  --cell-width: 0.75;
  flex: 0 0 calc(var(--base-width) * var(--cell-width)) !important;
}
.InvoicePreview .SimpleTable .SimpleTable-Row > .SimpleTable-Cell.SCHEDULED_DATE, .InvoicePreview .SimpleTable .SimpleTable-Row > .SimpleTable-Cell.CREW_ID {
  flex: 0 0 calc(var(--base-width) * var(--cell-width)) !important;
}
.InvoicePreview .SimpleTable .SimpleTable-Row > .SimpleTable-Cell.RATE, .InvoicePreview .SimpleTable .SimpleTable-Row > .SimpleTable-Cell.SAVINGS {
  --cell-width: 1;
  flex: 0 0 calc(var(--base-width) * var(--cell-width)) !important;
}
.InvoicePreview .SimpleTable .SimpleTable-Row > .SimpleTable-Cell.PU_LOCATION, .InvoicePreview .SimpleTable .SimpleTable-Row > .SimpleTable-Cell.DO_LOCATION {
  flex: 1 0 calc(var(--base-width) / var(--cell-width)) !important;
}
.InvoicePreview .SimpleTable .SimpleTable-Body .SimpleTable-Row {
  height: 2.5rem;
}
.InvoicePreview .SimpleTable .SimpleTable-Body .SimpleTable-Row > .SimpleTable-Cell.RATE button:before {
  content: "\$";
}
.InvoicePreview .SimpleTable .SimpleTable-Body .SimpleTable-Row.COMBINE-LIGHT {
  background-color: #effcff;
}
.InvoicePreview .SimpleTable .SimpleTable-Body .SimpleTable-Row.COMBINE-DARK {
  background-color: #e3f9ff;
}
.InvoicePreview .SimpleTable .SimpleTable-Body .SimpleTable-Row.SUBTOTAL {
  background-color: rgba(0, 0, 0, 0.045);
}
.InvoicePreview .SimpleTable .SimpleTable-Body .SimpleTable-Row.SUBTOTAL > .SimpleTable-Cell {
  font-weight: 800;
}
.InvoicePreview .SimpleTable .SimpleTable-Body .SimpleTable-Row.SUBTOTAL > .SimpleTable-Cell:not(.SAVINGS, .DO_LOCATION):not(.RATE) {
  content-visibility: hidden;
}
.InvoicePreview .SimpleTable .SimpleTable-Body .SimpleTable-Row.SUBTOTAL > .SimpleTable-Cell.DO_LOCATION, .InvoicePreview .SimpleTable .SimpleTable-Body .SimpleTable-Row.SUBTOTAL > .SimpleTable-Cell.SAVINGS {
  justify-content: end;
}
.InvoicePreview .SimpleTable .SimpleTable-Body .SimpleTable-Row.SUBTOTAL > .SimpleTable-Cell.RATE:before {
  content: "\$";
}
.InvoicePreview .SimpleTable .SimpleTable-Body .SimpleTable-Row.SUBTOTAL > .SimpleTable-Cell.SAVINGS:before {
  content: "";
}
.InvoicePreview .SimpleTable .SimpleTable-Body .SimpleTable-Row.IGNORED > .SimpleTable-Cell {
  border: none;
}
.InvoicePreview .SimpleTable .SimpleTable-Body .SimpleTable-Row.IGNORED > .SimpleTable-Cell.INDEX {
  --cell-width: 3;
  justify-content: flex-start;
  gap: 1rem;
  flex: 0 0 calc(var(--base-width) * var(--cell-width)) !important;
}
.InvoicePreview .SimpleTable .SimpleTable-Body .SimpleTable-Row.IGNORED > .SimpleTable-Cell:not(.INDEX) {
  content-visibility: hidden;
}

@media print {
  .InvoicePreview-Header {
    width: 100% !important;
  }
  .InvoicePreview-Header,
  .InvoicePreview-Header * {
    color: var(--bs-body-color) !important;
  }
  .InvoicePreview-Header {
    border: none;
    box-shadow: none !important;
  }
  .InvoicePreview-Header > div + div,
  .InvoicePreview-Header .btn {
    display: none !important;
  }
  .InvoicePreview-Header i {
    visibility: hidden !important;
  }
  .InvoicePreview-Header .FormField:first-child .form-control {
    border: none !important;
    padding: 0;
  }
  .InvoicePreview-Header .FormField:first-child .FormField-Label {
    padding: 0 !important;
    margin: 0 0 0.6rem 0 !important;
    border: none !important;
    line-height: 1.2 !important;
    font-weight: 800 !important;
    height: auto !important;
    text-transform: unset !important;
    font-size: 1rem !important;
  }
  .InvoicePreview-Header ul:last-child {
    display: none !important;
  }
  .InvoicePreview-Header .collapse:not(.show) {
    display: block;
  }
}
.Table.UpdatedInvoicePreviewTable {
  width: calc(100% + 3rem);
}
.Table.UpdatedInvoicePreviewTable table {
  --sp-table-header-bg: var(--bs-secondary-subtle);
  background-color: #fff;
}
.Table.UpdatedInvoicePreviewTable table .TableRow {
  --cell-count: 14;
  --location-width: 15%;
}
.Table.UpdatedInvoicePreviewTable table .TableRow:has(.CREW_ID) {
  --cell-count: 15;
  --location-width: 12.5%;
}
.Table.UpdatedInvoicePreviewTable table .TableRow {
  --cell-width: calc(100% / var(--cell-count));
}
.Table.UpdatedInvoicePreviewTable table .TableRow .TableCell {
  --cell-span: attr(colspan type(<number>), 1);
  width: calc(var(--cell-width) * var(--cell-span));
  border-left: 1px solid var(--bs-gray-300);
}
.Table.UpdatedInvoicePreviewTable table .TableRow .TableCell .TableCell-Content {
  align-content: center;
  text-align: center;
  padding-top: 0;
  padding-bottom: 0;
  font-weight: 700;
}
.Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.INDEX, .Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.TYPE {
  width: 5%;
}
.Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.SCHEDULED_DATE, .Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.SCHEDULED_TIME, .Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.IMPORT_TIME {
  width: 7%;
}
.Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.AIRPORT_CODE, .Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.SERVICER_IATA_AIRLINE_CODE, .Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.FLIGHT_NUMBER, .Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.PILOTS, .Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.ATTENDANTS, .Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.CREW_ID {
  width: 5%;
}
.Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.DO_LOCATION, .Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.PU_LOCATION {
  width: var(--location-width);
}
.Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.SAVINGS, .Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.RATE {
  width: 7%;
}
.Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.SUBTOTAL .TableCell-Content {
  text-align: right;
}
.Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.SUBTOTAL, .Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.SUBTOTAL + .TableCell {
  background-color: rgba(0, 0, 0, 0.1);
}
.Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.SUBTOTAL .TableCell-Content, .Table.UpdatedInvoicePreviewTable table .TableRow .TableCell.SUBTOTAL + .TableCell .TableCell-Content {
  font-weight: 800;
}`, "",{"version":3,"sources":["webpack://./src/pages/InvoicePreview/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,6CAAA;AACF;;AAEE;;EAEE,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,wCAAA;EACA,gDAAA;AACJ;AACI;;EACE,mDAAA;EACA,4DAAA;AAEN;AAEE;EACE,0BAAA;EACA,wBAAA;AAAJ;AAEE;EACE,aAAA;AAAJ;;AAIA;EACE,kBAAA;AADF;AAEE;EACE,cAAA;EACA,iBAAA;EACA,gCAAA;AAAJ;AACI;EACE,YAAA;EACA,gBAAA;AACN;AAEE;EACE,aAAA;AAAJ;AAEE;EAEE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,8EAAA;EACA,mBAAA;EACA,oBAAA;AADJ;AAKI;EACE,eAAA;AAHN;AAKI;EACE,YAAA;EACA,kBAAA;AAHN;AAOE;EACE,eAAA;AALJ;AAQE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AANJ;;AAWE;EACE,SAAA;AARJ;;AAgBM;EACE,gBAAA;EACA,4CAAA;EACA,eAAA;AAbR;AAcQ;EAME,iBAAA;EACA,gEAAA;AAjBV;AAmBQ;EAGE,kBAAA;EACA,gEAAA;AAnBV;AAqBQ;EAEE,gEAAA;AApBV;AAsBQ;EAEE,eAAA;EACA,gEAAA;AArBV;AAuBQ;EAEE,gEAAA;AAtBV;AAuCM;EACE,cAAA;AArCR;AAyCc;EACE,YAAA;AAvChB;AA4CQ;EACE,yBAAA;AA1CV;AA4CQ;EACE,yBAAA;AA1CV;AA6CQ;EACE,sCAAA;AA3CV;AA4CU;EACE,gBAAA;AA1CZ;AA2CY;EACE,0BAAA;AAzCd;AA2CY;EAEE,oBAAA;AA1Cd;AA6Cc;EACE,YAAA;AA3ChB;AA+Cc;EACE,WAAA;AA7ChB;AAmDU;EACE,YAAA;AAjDZ;AAkDY;EACE,eAAA;EACA,2BAAA;EACA,SAAA;EACA,gEAAA;AAhDd;AAkDY;EACE,0BAAA;AAhDd;;AAyDA;EACE;IACE,sBAAA;EAtDF;EAuDE;;IAEE,sCAAA;EArDJ;EAiDA;IAME,YAAA;IACA,2BAAA;EApDF;EAqDE;;IAEE,wBAAA;EAnDJ;EAqDE;IACE,6BAAA;EAnDJ;EAsDI;IACE,uBAAA;IACA,UAAA;EApDN;EAsDI;IACE,qBAAA;IACA,+BAAA;IACA,uBAAA;IACA,2BAAA;IACA,2BAAA;IACA,uBAAA;IACA,gCAAA;IACA,0BAAA;EApDN;EAuDE;IACE,wBAAA;EArDJ;EAuDE;IACE,cAAA;EArDJ;AACF;AAyDA;EACE,wBAAA;AAvDF;AAwDE;EACE,gDAAA;EACA,sBAAA;AAtDJ;AAuDI;EACE,gBAAA;EACA,qBAAA;AArDN;AAsDM;EACE,gBAAA;EACA,uBAAA;AApDR;AA+CI;EAOE,4CAAA;AAnDN;AAoDM;EACE,4CAAA;EACA,iDAAA;EACA,yCAAA;AAlDR;AAoDQ;EACE,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAlDV;AAoDQ;EAEE,SAAA;AAnDV;AAqDQ;EAGE,SAAA;AArDV;AAuDQ;EAME,SAAA;AA1DV;AA4DQ;EAEE,4BAAA;AA3DV;AA6DQ;EAEE,SAAA;AA5DV;AA+DU;EACE,iBAAA;AA7DZ;AA+DU;EAEE,oCAAA;AA9DZ;AA+DY;EACE,gBAAA;AA7Dd","sourcesContent":[".InvoicePreview-Wrapper {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  min-height: 100px;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n}\n.InvoicePreview-Header {\n  .InvoicePreview-BillToName,\n  .InvoicePreview-BillToAddress {\n    background: transparent;\n    font-size: inherit;\n    color: inherit;\n    border: solid 1px transparent !important;\n    box-shadow: 0 0 0 0.25rem transparent !important;\n\n    &:focus {\n      border: solid 1px var(--bs-border-color) !important;\n      box-shadow: 0 0 0 0.25rem rgba(27, 62, 111, 0.15) !important;\n    }\n  }\n\n  .ant-picker-input input {\n    font-size: 1rem !important;\n    color: var(--bs-primary);\n  }\n  li > h6 {\n    display: flex;\n  }\n}\n\n.InvoicePreview-Totals {\n  position: relative;\n  .summary-row {\n    height: 2.5rem;\n    background: white;\n    border-bottom: 1px solid #e0e0e0;\n    .Input {\n      border: none;\n      box-shadow: none;\n    }\n  }\n  .CurrencyInput:before {\n    display: none;\n  }\n  &:after {\n    // This is the drop shadow effect above the line items\n    content: '';\n    position: absolute;\n    bottom: 100%; // This puts it above the parent element\n    left: 0; // Aligns the pseudo-element with the left edge of the parent element\n    z-index: 500;\n    width: 100%;\n    height: 60px;\n    background: linear-gradient(rgba(200, 200, 210, 0), rgba(200, 200, 210, 0.25));\n    padding-right: 50px;\n    pointer-events: none;\n  }\n\n  .discount {\n    span:first-child {\n      padding-left: 0;\n    }\n    &::before {\n      content: '-';\n      font-size: 1.25rem;\n    }\n  }\n\n  .input-group-sm > .form-control {\n    font-size: 1rem;\n  }\n\n  .TotalSavings {\n    outline: none;\n    border: 0;\n    background: transparent;\n    text-align: end;\n  }\n}\n\n.QueryFilters {\n  &.InvoicePreviewFilters {\n    gap: 8rem;\n  }\n}\n\n.InvoicePreview {\n  .SimpleTable {\n    // CELL WIDTHS (UNIVERSAL)\n    .SimpleTable-Row {\n      > .SimpleTable-Cell {\n        --base-count: 14;\n        --base-width: calc(100% / var(--base-count));\n        --cell-width: 1;\n        &.INDEX,\n        &.TYPE,\n        &.AIRPORT_CODE,\n        &.SERVICER_IATA_AIRLINE_CODE,\n        &.PILOTS,\n        &.ATTENDANTS {\n          --cell-width: 0.5;\n          flex: 0 0 calc(var(--base-width) * var(--cell-width)) !important;\n        }\n        &.SCHEDULED_TIME,\n        &.FLIGHT_NUMBER,\n        &.IMPORT_TIME {\n          --cell-width: 0.75;\n          flex: 0 0 calc(var(--base-width) * var(--cell-width)) !important;\n        }\n        &.SCHEDULED_DATE,\n        &.CREW_ID {\n          flex: 0 0 calc(var(--base-width) * var(--cell-width)) !important;\n        }\n        &.RATE,\n        &.SAVINGS {\n          --cell-width: 1;\n          flex: 0 0 calc(var(--base-width) * var(--cell-width)) !important;\n        }\n        &.PU_LOCATION,\n        &.DO_LOCATION {\n          flex: 1 0 calc(var(--base-width) / var(--cell-width)) !important;\n        }\n      }\n      // CELL COLORS\n      //> .SimpleTable-Cell {\n      //  &.INDEX,\n      //  &.SCHEDULED_DATE,\n      //  &.SCHEDULED_TIME,\n      //  &.PILOTS,\n      //  &.ATTENDANTS,\n      //  &.RATE {\n      //    background-color: rgba(0, 0, 0, 0.045);\n      //  }\n      //}\n    }\n    // Cell Content (BODY)\n    .SimpleTable-Body {\n      .SimpleTable-Row {\n        height: 2.5rem;\n        > .SimpleTable-Cell {\n          &.RATE {\n            button {\n              &:before {\n                content: '$';\n              }\n            }\n          }\n        }\n        &.COMBINE-LIGHT {\n          background-color: #effcff;\n        }\n        &.COMBINE-DARK {\n          background-color: #e3f9ff;\n        }\n        // Sub Total Overrides\n        &.SUBTOTAL {\n          background-color: rgba(0, 0, 0, 0.045);\n          > .SimpleTable-Cell {\n            font-weight: 800;\n            &:not(.SAVINGS, .DO_LOCATION):not(.RATE) {\n              content-visibility: hidden;\n            }\n            &.DO_LOCATION,\n            &.SAVINGS {\n              justify-content: end;\n            }\n            &.RATE {\n              &:before {\n                content: '$';\n              }\n            }\n            &.SAVINGS {\n              &:before {\n                content: '';\n              }\n            }\n          }\n        }\n        &.IGNORED {\n          > .SimpleTable-Cell {\n            border: none;\n            &.INDEX {\n              --cell-width: 3;\n              justify-content: flex-start;\n              gap: 1rem;\n              flex: 0 0 calc(var(--base-width) * var(--cell-width)) !important;\n            }\n            &:not(.INDEX) {\n              content-visibility: hidden;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media print {\n  .InvoicePreview-Header {\n    width: 100% !important;\n    &,\n    * {\n      color: var(--bs-body-color) !important;\n    }\n    border: none;\n    box-shadow: none !important;\n    > div + div,\n    .btn {\n      display: none !important;\n    }\n    i {\n      visibility: hidden !important;\n    }\n    .FormField:first-child {\n      .form-control {\n        border: none !important;\n        padding: 0;\n      }\n      .FormField-Label {\n        padding: 0 !important;\n        margin: 0 0 0.6rem 0 !important;\n        border: none !important;\n        line-height: 1.2 !important;\n        font-weight: 800 !important;\n        height: auto !important;\n        text-transform: unset !important;\n        font-size: 1rem !important;\n      }\n    }\n    ul:last-child {\n      display: none !important;\n    }\n    .collapse:not(.show) {\n      display: block;\n    }\n  }\n}\n\n.Table.UpdatedInvoicePreviewTable {\n  width: calc(100% + 3rem);\n  table {\n    --sp-table-header-bg: var(--bs-secondary-subtle);\n    background-color: #fff;\n    .TableRow {\n      --cell-count: 14;\n      --location-width: 15%;\n      &:has(.CREW_ID) {\n        --cell-count: 15;\n        --location-width: 12.5%;\n      }\n      --cell-width: calc(100% / var(--cell-count));\n      .TableCell {\n        --cell-span: attr(colspan type(<number>), 1);\n        width: calc(var(--cell-width) * var(--cell-span));\n        border-left: 1px solid var(--bs-gray-300);\n\n        .TableCell-Content {\n          align-content: center;\n          text-align: center;\n          padding-top: 0;\n          padding-bottom: 0;\n          font-weight: 700;\n        }\n        &.INDEX,\n        &.TYPE {\n          width: 5%; // 10%\n        }\n        &.SCHEDULED_DATE,\n        &.SCHEDULED_TIME,\n        &.IMPORT_TIME {\n          width: 7%; // 21%\n        }\n        &.AIRPORT_CODE,\n        &.SERVICER_IATA_AIRLINE_CODE,\n        &.FLIGHT_NUMBER,\n        &.PILOTS,\n        &.ATTENDANTS,\n        &.CREW_ID {\n          width: 5%; // 30%\n        }\n        &.DO_LOCATION,\n        &.PU_LOCATION {\n          width: var(--location-width); // 30%\n        }\n        &.SAVINGS,\n        &.RATE {\n          width: 7%; // 14%\n        }\n        &.SUBTOTAL {\n          .TableCell-Content {\n            text-align: right;\n          }\n          &,\n          & + .TableCell {\n            background-color: rgba(0, 0, 0, 0.1);\n            .TableCell-Content {\n              font-weight: 800;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
